import { usePathname } from "next/navigation";
import { flattenUrlsWithPeers } from "./utils";

export type HrefLabel = {
  href: string;
  label: string;
};

export type Crumb = HrefLabel & {
  peers?: HrefLabel[];
};

function formatSegment(segment: string) {
  return segment
    .replace(/-/g, " ")
    .replace(/\b\w/g, char => char.toUpperCase());
}

export function useBreadcrumbs(showCurrentPage: boolean): Crumb[] {
  const pathname = usePathname();
  const segments = pathname.split("/").filter(Boolean);
  const finalSegments = showCurrentPage ? segments : segments.slice(0, -1);

  const { peerMap } = flattenUrlsWithPeers(undefined, ["home", "contact_us"]);

  const crumbs: Crumb[] = finalSegments.map((segment, i) => {
    const fullPath = `/${segments.slice(0, i + 1).join("/")}`;
    const parentPath = `/${segments.slice(0, i).join("/")}`;
    const peers =
      peerMap[parentPath]?.length > 1 ? peerMap[parentPath] : undefined;

    return {
      href: fullPath,
      label: formatSegment(segment),
      peers: peers,
    };
  });

  return [{ href: "/", label: "Home" }, ...crumbs];
}
